
import axios from "../api/axiosInstance";

export const getSalesKpi = (customerId,groupId) => {
  return axios.get(`/Report/GetSalesKpi?customerId=${customerId}&groupId=${groupId}`);
};


export const getNotBoughtProducts = (customerId,groupId) => {
  return axios.get(`/Report/GetNotBoughtProducts?customerId=${customerId}&groupId=${groupId}`);
};


export const getSalesByGroup = (customerId) => {
  return axios.get(`/Report/GetSalesByGroup?customerId=${customerId}`);
};

export const getProductGroups = () =>
  axios.get(`/Report/GetProductGroups`);

export const getTopProducts = (customerId,groupId) => {
  return axios.get(`/Report/GetTopProducts?customerId=${customerId}&groupId=${groupId}`);
};